import React, { useState } from 'react';
import CredentialsModal from './CredentialsModal';
import QuotaModal from './QuotaModal';
import './SiteCard.css';

export default function SiteCard({ site, actionStatus, onAction, onDelete, onEdit }) {
  const [expanded, setExpanded] = useState(false);
  const [showCreds, setShowCreds] = useState(false);
  const [showQuota, setShowQuota] = useState(false);
  const allRunning = site.containers.length > 0 && site.containers.every(c => c.running);
  const anyRunning = site.containers.some(c => c.running);
  const busy = !!actionStatus;

  function statusTag() {
    if (site.containers.length === 0) return <span className="tag tag-yellow">no containers</span>;
    if (allRunning) return <span className="tag tag-green">● running</span>;
    if (anyRunning) return <span className="tag tag-yellow">◑ partial</span>;
    return <span className="tag tag-red">○ stopped</span>;
  }

  return (
    <div className={`site-card ${allRunning ? 'running' : ''}`}>
      <div className="site-card-header" onClick={() => setExpanded(e => !e)}>
        <div className="site-info">
          <div className="site-domain">{site.domain}</div>
          <div className="site-meta">
            <span className="tag tag-blue">{site.containers.length} containers</span>
            {statusTag()}
          </div>
        </div>
        <span className="expand-arrow">{expanded ? '▲' : '▼'}</span>
      </div>

      <div className="site-actions">
        <button
          className="btn-ghost btn-sm"
          onClick={() => onAction(site.domain, 'start')}
          disabled={busy || allRunning}
          title="Start"
        >▶ Start</button>
        <button
          className="btn-ghost btn-sm"
          onClick={() => onAction(site.domain, 'stop')}
          disabled={busy || !anyRunning}
          title="Stop"
        >■ Stop</button>
        <button
          className="btn-ghost btn-sm"
          onClick={() => onAction(site.domain, 'restart')}
          disabled={busy}
          title="Restart"
        >↺ Restart</button>
        <button
          className="btn-ghost btn-sm"
          onClick={() => onEdit(site.domain)}
          title="Edit compose.yml"
        >✎ Compose</button>
        <button
          className="btn-ghost btn-sm"
          onClick={() => setShowQuota(true)}
          title="View/edit disk quota"
        >💾 Quota</button>
        {site.hasCredentials && (
          <button
            className="btn-ghost btn-sm"
            onClick={() => setShowCreds(true)}
            title="View credentials"
          >🔑 Creds</button>
        )}
        <button
          className="btn-danger btn-sm"
          onClick={() => onDelete(site.domain)}
          disabled={busy}
          title="Delete site"
        >✕</button>
        {busy && <span className="busy-label">{actionStatus}ing...</span>}
      </div>

      {expanded && (
        <div className="containers-list">
          {site.containers.length === 0 ? (
            <div className="no-containers">No containers found</div>
          ) : (
            site.containers.map(c => (
              <div key={c.name} className="container-row">
                <span className={`container-dot ${c.running ? 'green' : 'red'}`} />
                <span className="container-name">{c.name}</span>
                <span className="container-image">{c.image}</span>
                <span className={`tag ${c.running ? 'tag-green' : 'tag-red'}`} style={{ fontSize: '10px' }}>
                  {c.running ? 'up' : 'down'}
                </span>
              </div>
            ))
          )}
        </div>
      )}

      {showCreds && (
        <CredentialsModal domain={site.domain} onClose={() => setShowCreds(false)} />
      )}
      {showQuota && (
        <QuotaModal domain={site.domain} onClose={() => setShowQuota(false)} />
      )}
    </div>
  );
}
